import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import { AUITabNavigation } from '@ancert/aui-tab';
import { useNotification } from '@ancert/aui-notification-context';
import ModalReestablecerContrasena from '../../components/ModalReestablecerContrasena';
import ConsultarDenunciaHeader from '../../components/ConsultarDenunciaHeader';
import DatosPersonalesConsulta from './DatosPersonalesConsulta';
import Mensajes from './Mensajes';
import DatosComunicacionConsulta from './DatosComunicacionConsulta';
import PersonasArchivosConsulta from './PersonasArchivosConsulta';
import { getDetalleDenunciaSecure, getMensajesDenuncia } from '../../services/denuncias.service';
import FORMAT_DATE from '../../constants/dates.constants';
import { PERMISO_GESTION_DENUNCIA, ROUTES } from '../../constants';
import { useLoading } from '../../context/loading.context';
import { useSession } from '../../context/session.context';
import GestionDenuncia from './GestionDenuncia';
import { ROL } from '../../lib/role.enum';

const DEFAULT_TABS = [
  {
    header: 'Mensajes',
  },
  {
    header: 'Datos de la comunicación',
  },
  {
    header: 'Datos Personales',
  },
  {
    header: 'Personas relacionadas y archivos adjuntos',
  },
];

const ConsultarDenuncia = ({ idDenuncia }) => {
  const history = useHistory();
  const { openNotification } = useNotification();
  const { uniqueComplaint, getRenewPassword, getUser } = useSession();
  const [tabs, setTabs] = useState(DEFAULT_TABS);
  const [activeTab, setActiveTab] = useState(0);
  const [isShow, setShow] = useState(false);
  const [mensajesData, setMensajesData] = useState([]);
  const [complaint, setComplaint] = useState(null);
  const [gestionPermission, setGestionPermission] = useState(false);
  const { isLoading, setIsLoading } = useLoading();

  const getDataDenuncia = async (id) => {
    const { status, data: result, error } = await getDetalleDenunciaSecure({ id });
    if (status === 200) {
      setComplaint(result);
      return result.id;
    }
    const { message } = error;
    openNotification({
      title: 'Error',
      content: <div>{message || 'Ha ocurrido un error'}</div>,
      type: 'error',
      centerButtons: true,
    });
    return null;
  };

  const getMensajes = async (id) => {
    const { status, data: result, error } = await getMensajesDenuncia({ id });
    if (status === 200) {
      setMensajesData(result);
      return true;
    }
    const { message } = error;
    openNotification({
      title: 'Error',
      content: <div>{message || 'Ha ocurrido un error'}</div>,
      type: 'error',
      centerButtons: true,
    });
    return false;
  };

  const verPermisos = () => {
    const { role } = getUser();
    const havePermission = PERMISO_GESTION_DENUNCIA.some((rol) => rol === role);
    setGestionPermission(havePermission);
    if (havePermission) {
      const newTabs = [...tabs];
      newTabs.push({
        header: 'Gestión de denuncia',
      });
      setTabs(newTabs);
    }
  };

  const loadData = async () => {
    const complaintId = await getDataDenuncia(idDenuncia);
    if (complaintId) await getMensajes(complaintId);
  };

  useEffect(() => {
    setIsLoading(true);
    loadData();
    setShow(getRenewPassword());
    verPermisos();
    setIsLoading(false);
  }, []);

  const renderContent = () => {
    if (activeTab === 0) {
      return (
        <Mensajes
          complaintId={complaint?.id}
          complaintDate={complaint?.creationDate}
          compaintStatus={complaint?.status}
          data={mensajesData}
          reload={loadData}
        />
      );
    }
    if (activeTab === 1) {
      return <DatosComunicacionConsulta data={complaint} />;
    }
    if (activeTab === 2) {
      return <DatosPersonalesConsulta data={complaint} />;
    }
    if (activeTab === 3) {
      return <PersonasArchivosConsulta data={complaint} />;
    }
    if (activeTab === 4 && gestionPermission) {
      return (
        <GestionDenuncia
          data={complaint}
          reloadMensajes={() => getMensajes(complaint?.id)}
          reloadComplaint={() => getDataDenuncia(idDenuncia)}
        />
      );
    }
    return <div />;
  };

  const handleClick = (e) => {
    setActiveTab(e.index);
  };

  const DenunciaTitle = () => {
    if (!complaint) {
      return '';
    }
    const { id, publicId } = complaint;
    const { role } = getUser();
    const finalId = [ROL.ADMINISTRADOR, ROL.RESPONSABLE].includes(role) ? id : publicId;
    return `Denuncia ${finalId}`;
  };

  const onClickBack = () => {
    const { role } = getUser();
    if (role === ROL.DENUNCIANTE) {
      history.push(ROUTES.LISTADO_DENUNCIA);
      return;
    }
    history.push(ROUTES.BACK_OFFICE);
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className="o-sii-main-container">
      <ConsultarDenunciaHeader
        title={DenunciaTitle()}
        date={
          complaint?.creationDate &&
          `(${format(new Date(complaint?.creationDate), FORMAT_DATE.FRONT)} - ${format(
            new Date(complaint?.creationDate),
            FORMAT_DATE.HOURS_MINUTES
          )}h)`
        }
        status={complaint?.status}
        canGoBack={!uniqueComplaint}
        onClickBack={onClickBack}
      />
      <AUITabNavigation className="" onTabChange={handleClick} activeTab={activeTab} tabs={tabs} />
      {renderContent()}
      <ModalReestablecerContrasena show={isShow} onClose={() => setShow(false)} />
    </div>
  );
};

ConsultarDenuncia.propTypes = {
  idDenuncia: string.isRequired,
};

export default ConsultarDenuncia;
